// extracted by mini-css-extract-plugin
export default {"cls1":"Ja_Of0tupw_OwEEGFxBA","cls2":"O103X0cgDiNWdtIReD_7 Ja_Of0tupw_OwEEGFxBA"};